<div class="flex flex-col items-center justify-center min-h-[60vh] px-4">

  <div class="bg-white rounded-2xl shadow-xl px-10 py-8 w-full max-w-md text-center">

    <div class="text-red-500 text-6xl mb-4">
      <i class="fas fa-triangle-exclamation"></i>
    </div>

    <h1 class="text-2xl font-bold text-gray-800 mb-2">
      {{ 'vues.ipad.error.title' | translate }}
    </h1>

    <p class="text-gray-500 mb-6">
      {{ 'vues.ipad.error.description' | translate }}
    </p>

    <button (click)="goHome()"
      class="w-full py-3 rounded-lg bg-blue-500 hover:bg-blue-600 text-white font-semibold text-sm cursor-pointer transition-colors">
      {{ 'vues.ipad.back.home' | translate }}
    </button>

  </div>
</div>
